(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cl-promo-bar"] && !Shopify.designMode) return;
  try {
    
  function initialisePromoMarquee(scope = document) {
    scope.querySelectorAll('.cl-promo cl-marquee').forEach((marquee) => {
      const track = marquee.querySelector('.cl-marquee__track');
      const group = track?.querySelector('.cl-marquee__group:not([aria-hidden="true"])');

      if (!track || !group || marquee.dataset.promoMarqueeReady) return;
      marquee.dataset.promoMarqueeReady = 'true';

      const originalItems = Array.from(group.children).map((item) => item.cloneNode(true));
      if (!originalItems.length) return;
      const mobile = matchMedia('(width < 60rem)');
      let fadeTimer;
      let activeIndex = 0;

      const showMobileItem = (items) => {
        items.forEach((item, index) => {
          item.classList.toggle('is-active', index === activeIndex);
          item.inert = index !== activeIndex;
        });
      };

      const setupMobileFade = () => {
        window.clearInterval(fadeTimer);
        group.replaceChildren(...originalItems.map((item) => item.cloneNode(true)));
        track.querySelectorAll('.cl-marquee__group[aria-hidden="true"]').forEach((clone) => clone.remove());
        const items = Array.from(group.children);
        activeIndex = Math.min(activeIndex, items.length - 1);
        showMobileItem(items);
        if (items.length > 1) {
          fadeTimer = window.setInterval(() => {
            if (group.matches(':focus-within')) return;
            activeIndex = (activeIndex + 1) % items.length;
            showMobileItem(items);
          }, 3500);
        }
      };

      const fillAndClone = () => {
        if (!marquee.clientWidth) return;

        if (mobile.matches) {
          setupMobileFade();
          return;
        }

        window.clearInterval(fadeTimer);
        group.replaceChildren(...originalItems.map((item) => item.cloneNode(true)));

        // Repeat items until one group is wider than the viewport so the loop never shows a gap.
        let safety = 0;
        while (group.scrollWidth < marquee.clientWidth && safety < 50) {
          originalItems.forEach((item) => {
            const copy = item.cloneNode(true);
            copy.removeAttribute('id');
            copy.setAttribute('aria-hidden', 'true');
            copy.setAttribute('inert', '');
            group.appendChild(copy);
          });
          safety += 1;
        }

        track.querySelectorAll('.cl-marquee__group[aria-hidden="true"]').forEach((clone) => clone.remove());
        const clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        track.appendChild(clone);
      };

      requestAnimationFrame(fillAndClone);
      const resizeObserver = new ResizeObserver(fillAndClone);
      resizeObserver.observe(marquee);
      mobile.addEventListener('change', fillAndClone);
    });
  }

  initialisePromoMarquee();
  document.addEventListener('shopify:section:load', (event) => initialisePromoMarquee(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-statement-logos"] && !Shopify.designMode) return;
  try {
    
  function enableLogoCloneHover(scope = document) {
    scope.querySelectorAll('.cl-statement .cl-logos').forEach((marquee) => {
      const track = marquee.querySelector('.cl-marquee__track');
      if (!track || marquee.dataset.cloneHoverReady) return;

      marquee.dataset.cloneHoverReady = 'true';

      const enableHover = () => {
        track.querySelectorAll('.cl-marquee__group[aria-hidden="true"]').forEach((group) => {
          group.removeAttribute('inert');
          group.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });
        });
      };

      enableHover();

      const observer = new MutationObserver(enableHover);
      observer.observe(track, { childList: true });
    });
  }

  enableLogoCloneHover();
  document.addEventListener('shopify:section:load', (event) => enableLogoCloneHover(event.target));

  } catch(e) { console.error(e); }
})();
})();
